// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1tT0Y","content":"styles_content__4dNJn","selectAll":"styles_selectAll__3C0W7"};